import { render, staticRenderFns } from "./ClientUrls.vue?vue&type=template&id=4e8f1b3a&"
import script from "./ClientUrls.vue?vue&type=script&lang=js&"
export * from "./ClientUrls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports